import { Dispatch } from 'redux';

import {
  getBillingInvoices,
  getCurrentUserSubscription,
} from 'store/actionCreators/subscriptions';
import { UserSubscription } from 'types';
import { isChfSubscriptionCurrency } from 'utils/subscriptionState';

export function isRenderableUserSubscription(
  subscription?: UserSubscription | null,
): boolean {
  if (!subscription?.id) return false;
  return (
    typeof subscription.maxMembers === 'number' &&
    typeof subscription.maxCommunities === 'number' &&
    typeof subscription.maxGroups === 'number' &&
    typeof subscription.maxStorage === 'number'
  );
}

/**
 * Refetch subscription after websocket billing events.
 * For CHF users, also kicks off invoices in parallel (fire-and-forget).
 */
export function syncSubscriptionFromWsEvent(
  dispatch: Dispatch,
  subscription?: UserSubscription | null,
): void {
  dispatch(getCurrentUserSubscription.trigger());

  if (isChfSubscriptionCurrency(subscription)) {
    dispatch(getBillingInvoices.trigger());
  }
}
